import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("{{! @glint-nocheck: not typesafe yet }}\n<section\n  class=\"cCA--analytics__display o--page__header u--hide-mobile\"\n  {{did-insert (perform this.getHighlightsData)}}\n  {{did-update (perform this.getHighlightsData) @targetDate}}\n>\n  <div class=\"cCA--analytics__tableHeader\">\n    {{svg-jar \"trending-up\" class=\"o--icon o--icon--md\"}}\n    <div class=\"cCA--analytics__items u--p__l u--p__r__0\">\n      <span class=\"u--text--bold\">\n        {{html-safe (t \"analytics.instagram.seven_day_profile_performance\")}}\n      </span>\n      <Shared::Ui::Button\n        @class=\"u--text--sm u--text--bold u--flex u--flex__nowrap u--flex__alignItems--center\"\n        @onClick={{this.transitionToOverview}}\n        @variant=\"actionLink\"\n      >\n        {{html-safe (t \"shared_phrases.view_more_analytics\")}}\n        {{svg-jar \"arrow-right\" class=\"o--icon o--icon--sm u--m__l__xs\"}}\n      </Shared::Ui::Button>\n    </div>\n  </div>\n  <div class=\"cCA--analytics__tableCell\">\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.followers}}</div>\n        {{#if this.hasFollowersChange}}\n          <div\n            class={{concat-classes\n              \"cCA--statGrid__valueChange\"\n              (if this.hasIncreaseInFollowers \"u--text--success\" \"u--text--danger\")\n            }}\n          >\n            {{this.followersChangeInPercent}}\n            {{if this.followersChangeInPercent \"%\"}}\n          </div>\n        {{/if}}\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.new_followers\"}}</div>\n    </div>\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.impressions}}</div>\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.impressions\"}}</div>\n    </div>\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.reach}}</div>\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.reach\"}}</div>\n    </div>\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.profileViews}}</div>\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.profile_views\"}}</div>\n    </div>\n  </div>\n</section>", {"contents":"{{! @glint-nocheck: not typesafe yet }}\n<section\n  class=\"cCA--analytics__display o--page__header u--hide-mobile\"\n  {{did-insert (perform this.getHighlightsData)}}\n  {{did-update (perform this.getHighlightsData) @targetDate}}\n>\n  <div class=\"cCA--analytics__tableHeader\">\n    {{svg-jar \"trending-up\" class=\"o--icon o--icon--md\"}}\n    <div class=\"cCA--analytics__items u--p__l u--p__r__0\">\n      <span class=\"u--text--bold\">\n        {{html-safe (t \"analytics.instagram.seven_day_profile_performance\")}}\n      </span>\n      <Shared::Ui::Button\n        @class=\"u--text--sm u--text--bold u--flex u--flex__nowrap u--flex__alignItems--center\"\n        @onClick={{this.transitionToOverview}}\n        @variant=\"actionLink\"\n      >\n        {{html-safe (t \"shared_phrases.view_more_analytics\")}}\n        {{svg-jar \"arrow-right\" class=\"o--icon o--icon--sm u--m__l__xs\"}}\n      </Shared::Ui::Button>\n    </div>\n  </div>\n  <div class=\"cCA--analytics__tableCell\">\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.followers}}</div>\n        {{#if this.hasFollowersChange}}\n          <div\n            class={{concat-classes\n              \"cCA--statGrid__valueChange\"\n              (if this.hasIncreaseInFollowers \"u--text--success\" \"u--text--danger\")\n            }}\n          >\n            {{this.followersChangeInPercent}}\n            {{if this.followersChangeInPercent \"%\"}}\n          </div>\n        {{/if}}\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.new_followers\"}}</div>\n    </div>\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.impressions}}</div>\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.impressions\"}}</div>\n    </div>\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.reach}}</div>\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.reach\"}}</div>\n    </div>\n    <div class=\"cCA--analytics__items\">\n      <div class=\"cCA--statGrid__valueWrapper\">\n        <div class=\"cCA--statGrid__value\">{{this.profileViews}}</div>\n      </div>\n      <div class=\"cCA--statGrid__unit\">{{t \"analytics.instagram.profile_views\"}}</div>\n    </div>\n  </div>\n</section>","moduleName":"later/components/schedule/analytics-highlights.hbs","parseOptions":{"srcName":"later/components/schedule/analytics-highlights.hbs"}});
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import moment from 'moment';

import { CALENDAR_VIEW_TYPES } from 'later/utils/constants';

import type RouterService from '@ember/routing/router-service';
import type { Calendar } from '@fullcalendar/core';
import type { Task } from 'ember-concurrency';
import type GroupModel from 'later/models/group';
import type SocialProfileModel from 'later/models/social-profile';
import type DynamoApiService from 'later/services/analytics/dynamo-api';
import type AuthService from 'later/services/auth';
import type ConfigService from 'later/services/calendar/config';
import type SegmentService from 'later/services/segment';
import type SelectedSocialProfilesService from 'later/services/selected-social-profiles';
import type UserConfigService from 'later/services/user-config';
import type { Moment } from 'moment';
import type { Maybe } from 'shared/types';
import type { InsightsPointRaw } from 'shared/types/analytics-data/insights';
import type { ProfileCountPointRaw } from 'shared/types/analytics-data/profile-counts';

const { WEEK } = CALENDAR_VIEW_TYPES;

interface AnalyticsHighlightsComponentArgs {
  targetDate: string;
}

interface Statistics {
  followers: number;
  impressions: number;
  reach: number;
  profileViews: number;
}

export default class AnalyticsHighlightsComponent extends Component<AnalyticsHighlightsComponentArgs> {
  @service declare auth: AuthService;
  @service('calendar/config') declare calendarConfig: ConfigService;
  @service('analytics/dynamo-api') declare dynamoApi: DynamoApiService;
  @service declare selectedSocialProfiles: SelectedSocialProfilesService;
  @service declare userConfig: UserConfigService;
  @service declare router: RouterService;
  @service declare segment: SegmentService;

  @tracked followers?: string;
  @tracked followersChangeInPercent?: Maybe<string>;
  @tracked impressions?: string;
  @tracked reach?: string;
  @tracked profileViews?: string;

  get socialProfile(): Maybe<SocialProfileModel> {
    return this.selectedSocialProfiles.firstProfile;
  }

  get socialProfileId(): string {
    return this.auth.currentSocialProfile.id;
  }

  get group(): GroupModel | undefined {
    return this.auth.lastGroup;
  }

  get timezone(): string {
    return this.userConfig.timeZoneIdentifier;
  }

  get calendarDate(): Moment {
    const targetDate = this.calendarConfig.fullCalendar?.getDate();
    return targetDate ? moment(targetDate).tz(this.timezone) : moment().tz(this.timezone);
  }

  get startDate(): Moment {
    return this.calendarDate.clone().subtract(7, 'day').startOf('day');
  }

  get endDate(): Moment {
    return this.calendarDate.clone().endOf('day');
  }

  get fullCalendar(): Maybe<Calendar> {
    return this.calendarConfig.fullCalendar;
  }

  get calendarStartTime(): Moment {
    return this.fullCalendar?.view.activeStart
      ? moment(this.fullCalendar?.view.activeStart)
      : moment().tz(this.timezone);
  }

  get calendarEndTime(): Moment {
    return this.fullCalendar?.view.activeEnd ? moment(this.fullCalendar?.view.activeEnd) : moment().tz(this.timezone);
  }

  get hasFollowersChange(): boolean {
    return Number(this.followersChangeInPercent) !== 0;
  }

  get hasIncreaseInFollowers(): boolean {
    return Number(this.followersChangeInPercent) > 0;
  }

  @action
  transitionToOverview(): void {
    if (!this.socialProfile?.isInstagram) {
      return;
    }
    this.segment.track('clicked-analytics-on-calendar', {
      calendar_view: this.calendarConfig.calendarView === WEEK ? 'week' : 'month'
    });
    this.router.transitionTo('cluster.analytics.profile.instagram.overview.index', this.socialProfile.urlName);
  }

  getHighlightsData = task(async () => {
    const startDate = this.startDate.clone();
    const endDate = this.endDate.clone();
    const profileInsights = await this.getProfileInsights.perform(startDate, endDate);
    const profileCounts = await this.getProfileCounts.perform(startDate, endDate);

    // note: workaround for a bug within dynamo-api service's helperAnalytics.fillData call
    // it inserts a null value object into the array
    const sanitizedProfileInsights = profileInsights.filter((insight) => insight.id !== null);
    const sanitizedProfileCounts = profileCounts.filter((counts) => counts.followed_by_count !== null);
    this.#extractData(sanitizedProfileInsights, sanitizedProfileCounts);
  });

  getProfileInsights: Task<InsightsPointRaw[], [startDate: Moment, endDate: Moment]> = task(
    async (startDate, endDate) => {
      const profileInsights = await this.dynamoApi.getProfileInsights.perform(
        startDate,
        endDate,
        false,
        this.socialProfileId
      );
      return profileInsights;
    }
  );

  getProfileCounts: Task<ProfileCountPointRaw[], [startDate: Moment, endDate: Moment]> = task(
    async (startDate, endDate) => {
      const profileCounts = await this.dynamoApi.getProfileCounts.perform(
        startDate,
        endDate,
        false,
        this.socialProfileId
      );
      return profileCounts;
    }
  );

  #calculateChangeRate(values: ProfileCountPointRaw[], key: keyof ProfileCountPointRaw): Maybe<string> {
    if (!values || !values.length) {
      return undefined;
    }
    const valueInitial = values[0][key];
    const valueEnd = values[values.length - 1][key];

    if (valueInitial && valueEnd && values.length > 1) {
      const growth = valueEnd - valueInitial;
      return ((growth / valueInitial) * 100).toFixed(2);
    }

    return undefined;
  }

  #extractData(profileInsights: InsightsPointRaw[], profileCounts: ProfileCountPointRaw[]): void {
    const result = profileInsights.reduce(
      (statistics: Statistics, currentValue: InsightsPointRaw) => {
        statistics.followers += currentValue.follower_count ?? 0;
        statistics.impressions += currentValue.impressions ?? 0;
        statistics.reach += currentValue.reach ?? 0;
        statistics.profileViews += currentValue.profile_views ?? 0;
        return statistics;
      },
      { followers: 0, impressions: 0, reach: 0, profileViews: 0 }
    );

    this.followers = Number(result.followers).toLocaleString();
    this.impressions = Number(result.impressions).toLocaleString();
    this.reach = Number(result.reach).toLocaleString();
    this.profileViews = Number(result.profileViews).toLocaleString();
    this.followersChangeInPercent = this.#calculateChangeRate(profileCounts, 'followed_by_count');
  }
}
